import { renderEventName, type EventNameParts } from '@lib/helpers/event-name-format'
import { calendarDay } from '@lib/validators/temporal.validator'

/** An invented couple, to show what a format names an event. */
export const SAMPLE_COUPLE: EventNameParts = { first: 'Jane', last: 'Doe', partnerFirst: 'John', partnerLast: 'Smith' }
export const SAMPLE_DATE = calendarDay('2027-06-12')

/** What the invented couple's event would be called in `format`. */
export function sampleName(format: string): string {
  return renderEventName(format, SAMPLE_COUPLE, SAMPLE_DATE)
}
